<div class="content">
  <div class="content-panel">
    <table class="table" aria-label="Liste des opérateurs">
      <thead>
        <tr>
          <th>SIRET</th>
          <th>CVI</th>
          <th>Raison sociale</th>
          <th></th>
        </tr>
      </thead>

      <tbody>
        <tr *ngFor="let operateur of operateurs">
          <td>{{ operateur.siret }}</td>
          <td>{{ operateur.cvi }}</td>
          <td>{{ operateur.raisonSociale }}</td>
          <td><fa-icon [ngbTooltip]="'Accéder au tableau de bord'" class="clickable-icon btn-primary button-operateur" [icon]="['far','address-card']" (click)="onNavigateToDashboardOperateur(operateur)"></fa-icon></td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
